import moment from 'moment';

type ShowClockOutPastScheduleProps = {
  now: string | Date;
  expectedEndTime: string | Date;
  disabledEditClockOutTime: boolean;
};

const showClockOutPastSchedule = ({
  now,
  expectedEndTime,
  disabledEditClockOutTime,
}: ShowClockOutPastScheduleProps) => {
  const fiveMinutesGraced = moment(expectedEndTime).add(5, 'minutes');
  const sixMinutesFromEndTime = moment(expectedEndTime).add(6, 'minutes');
  const currentTime = moment(now);

  if (disabledEditClockOutTime) {
    return expectedEndTime;
  }

  const isWithinGracePeriod =
    fiveMinutesGraced.isSameOrAfter(currentTime) &&
    currentTime.isBefore(sixMinutesFromEndTime) &&
    currentTime.isAfter(moment(expectedEndTime));

  return isWithinGracePeriod ? expectedEndTime : now;
};

const formatCaliforniaBreaks = (
  breaks: { duration: number; waived: boolean }[],
  isDurationMinutes?: boolean,
) => {
  const durationKey = isDurationMinutes ? 'duration_minutes' : 'duration';

  return breaks.map((mealBreak) => ({
    ...mealBreak,
    durationKey: mealBreak.waived ? 0 : mealBreak[durationKey as keyof typeof mealBreak],
  }));
};

export const ClockInOutDisplayHelpers = {
  showClockOutPastSchedule,
  formatCaliforniaBreaks,
};
